import React from 'react';
import { Tooltip } from 'react-tooltip';

import ColorBlock from '@components/common/ColorBlock/ColorBlock';

import useTranslation from '@hooks/useTranslation';

import style from './style.module.scss';

interface IProps {
  id: string;
}

interface TooltipData {
  status: string;
  data: Array<{
    name: string;
    color: string;
    total: number;
    percent: number;
  }>
}

const ActionItemsLegendTooltip: React.FC<IProps> = ({ id }) => {
  const { t } = useTranslation();

  return (
    <Tooltip
      id={id}
      place="bottom"
      clickable
      className={style.legendTooltip}
      render={({ content }) => {
        if (!content) {
          return null;
        }
        const row = JSON.parse(content);
        const { status, data }: TooltipData = row;
        const isNeedResponse = status === 'Need Response';
        return (
          <>
            <div className={style.statusName}>{t(status)}</div>
            {data.map((i, index) => (
              <div className={style.statusBlock} key={index}>
                <ColorBlock color={i.color as string} width={16} height={16} borderColor={isNeedResponse ? '' : '#B6BBC7'} />
                {t(i.name)}:
                <span className={style.total}>{i.total}</span>
                <span className={style.percent}>{i.percent}%</span>
              </div>
            ))}
          </>
        );
      }}
    />
  );
};

export default ActionItemsLegendTooltip;
